// extracted by mini-css-extract-plugin
export default {"wrapper":"ProductPayment_wrapper__QNpZ4","content":"ProductPayment_content__2bLTw","price":"ProductPayment_price__tFDnY","product-image":"ProductPayment_product-image__odkYS"};